import { render, staticRenderFns } from "./TableAction.vue?vue&type=template&id=91f1240a&scoped=true"
import script from "./TableAction.vue?vue&type=script&lang=ts"
export * from "./TableAction.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91f1240a",
  null
  
)

export default component.exports